import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Button, Paper, Typography, Table, TableContainer, TableHead, TableBody, TableRow, TableCell, IconButton } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';
import Loading from '../../../../components/loading';
import SuccessMessage from '../../../../components/successMessage';
import ErrorMessage from '../../../../components/errorMessage';
import api from '../../../../api/api';
import PrescriptionModalRouter from '../prescriptionModal/prescriptionModalRouter';

export default function PrescriptionListWeb() {

    const navigate = useNavigate();

    const { patientId } = useParams();

    const [isLoading, setLoading] = useState(false);
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const [prescriptions, setPrescriptions] = useState([]);
    const [isModalOpen, setModalOpen] = useState(false);

    const obterReceituariosDoPaciente = useCallback(() => {
        if (!patientId) {
            return;
        }
        api.get("/receituario/".concat(patientId), {
            headers: {
                Authorization: sessionStorage.getItem('token')
            }
        }).then((returnFromApi) => {
            setLoading(false);
            setPrescriptions(returnFromApi.data);

        }).catch((returnFromApi) => {
                setLoading(false);
                console.error("ops! ocorreu um erro" + returnFromApi);
                setErrorMessage(returnFromApi.response.data);
                if (returnFromApi.status === 401) {
                    navigate("/expired-session");
                }   
        });
    }, [patientId, navigate]);

    useEffect(() => {
        obterReceituariosDoPaciente();
    }, [obterReceituariosDoPaciente]);

    const onSavePrescription = (returnFromApi) => {
        if (returnFromApi.data) {
            setShowSuccessMessage(true);
            setSuccessMessage(returnFromApi.data);
        } else {
            setShowErrorMessage(true);
            setErrorMessage(returnFromApi.response.data);
        }
        setModalOpen(false);
        obterReceituariosDoPaciente();
    };

    const printPrescription = (prescriptionId) => {
        window.open(`/prescription-to-print/${patientId}/${prescriptionId}`, "_blank");
    };

    return (
        <>
            <Paper variant="outlined" sx={{ p: 3, borderRadius: 2 }}>

                <Loading isToHidden={isLoading === false} />
                {showSuccessMessage && <SuccessMessage message={successMessage} show={showSuccessMessage} setShow={setShowSuccessMessage} />}
                {showErrorMessage && <ErrorMessage message={errorMessage} show={showErrorMessage} setShow={setShowErrorMessage} />}

                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                    <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
                        Receituários
                    </Typography>
                    <Button variant="outlined" onClick={() => setModalOpen(true)}>
                        Adicionar Receituário
                    </Button>
                </Box>

                {prescriptions.length === 0 ? (
                    <Typography align="center" sx={{ py: 4 }}>
                        Nenhuma receita cadastrada ainda.
                    </Typography>
                ) : (
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Data</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Dentista</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid rgba(224, 224, 224, 1)' }}></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {prescriptions.map(p => (
                                    <TableRow key={p.receituarioId} hover>
                                        <TableCell>{p.data}</TableCell>
                                        <TableCell>{p.nomeDoDentista}</TableCell>
                                        <TableCell align="right">
                                            <IconButton color="primary"
                                                onClick={() => printPrescription(p.receituarioId)}>
                                                <PrintIcon />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </Paper>

            <PrescriptionModalRouter
                open={isModalOpen}
                onClose={() => setModalOpen(false)}
                onSave={onSavePrescription}
            />
        </>
    )
}